<template>
  <div class="error-page">
    <h2 class="headline text-purple"> 401</h2>

    <div class="error-content">
      <h3>
        <i class="fa fa-warning text-purple"></i> {{$t('message.401_error')}}</h3>
      <span v-if="message">{{ message }}</span>
      <span v-else>
        <p>{{$t('message.401_message')}} </p>
        <p>{{$t('message.401_message_2')}}</p>
        <slot name="cargo"></slot>
      </span>
      <br>
      <br>
      <div class="input-group text-xs-center">
        <div class="input-group-btn">
          <router-link to="/" class="btn bg-purple"> {{ $t('words.back')}} </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        message: null
      };
    },
    mounted() {
      this.message = this.$route.params.message;
    }
  };
</script>